import { FootPrintPadHoleType, LayerOrientation } from "@buildwithflux/models";
export function getSolderMaskExpansion(orientation, bakedRules) {
    switch (orientation) {
        case LayerOrientation.top:
            return bakedRules?.solderMaskExpansion?.topExpansion ?? 0;
        case LayerOrientation.bottom:
            return bakedRules?.solderMaskExpansion?.bottomExpansion ?? 0;
        default:
            return 0;
    }
}
export function getSolderMaskExpansionOnSize(orientation, bakedRules) {
    const maskExpansion = getSolderMaskExpansion(orientation, bakedRules);
    // If calculating solder mask expansion where Pad type of HOLE is detected, then expansion needs to be calculated
    // differently, relative to the hole size rather than the node size
    if (bakedRules && "hole" in bakedRules && bakedRules.hole?.holeType === FootPrintPadHoleType.nonPlatedHole) {
        const maskExpansionFromHole = bakedRules.solderMaskExpansion?.expansionFromTheHoleEdge ?? 0;
        // In the HOLE pad type case, chose expansion amount that is the larger or 'from hole' or 'from edge'
        const maskExpansionForHole = Math.max(maskExpansionFromHole, maskExpansion);
        return {
            x: bakedRules.hole.holeSize.x + Math.max(0, maskExpansionForHole * 2),
            y: bakedRules.hole.holeSize.y + Math.max(0, maskExpansionForHole * 2),
        };
    }
    return {
        x: Math.max(0, (bakedRules?.size.x ?? 0) + maskExpansion * 2),
        y: Math.max(0, (bakedRules?.size.y ?? 0) + maskExpansion * 2),
    };
}
//# sourceMappingURL=solderMaskExpansion.js.map